module.exports = __webpack_public_path__ + "img/icon-linkedin.7799e317.svg";